/* Klivlo — product page + cart drawer (vanilla JS, Shopify Ajax Cart API). Language-agnostic: all labels come from Liquid/locales. */
(() => {
  // Several sections include this file; run it only once so click handlers aren't registered twice
  if (window.KlivloCart) return;
  const SECTION = 'klivlo-cart-drawer';
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const drawer = () => document.getElementById('KlivloCartDrawer');

  async function cartRequest(path, body) {
    const d = drawer(); d && d.classList.add('is-busy');
    try {
      const res = await fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: SECTION, sections_url: location.pathname }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      if (data.sections && data.sections[SECTION]) renderDrawer(data.sections[SECTION]); else await refreshDrawer();
      return data;
    } finally { d && d.classList.remove('is-busy'); }
  }
  async function refreshDrawer() {
    const res = await fetch(root() + '?sections=' + SECTION);
    renderDrawer((await res.json())[SECTION]);
  }
  function renderDrawer(html) {
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const fresh = tmp.querySelector('#KlivloCartDrawer'), cur = drawer();
    if (!fresh || !cur) return;
    const open = cur.classList.contains('is-open');
    cur.replaceWith(fresh); if (open) fresh.classList.add('is-open');
    $$('[data-kv-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(el => el.textContent = fresh.dataset.count);
    document.dispatchEvent(new CustomEvent('klivlo:cart-updated', { detail: { count: fresh.dataset.count } }));
  }
  const openDrawer = () => { const d = drawer(); if (!d) return; d.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
  const closeDrawer = () => { const d = drawer(); if (!d) return; d.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
  window.KlivloCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };

  // 3 bags in one bundle line: visible props "<Bag> 1/2/3" (translated) + hidden _variant_ids for fulfilment
  const bundleProps = (prop, names, ids) => ({ [prop + ' 1']: names[0], [prop + ' 2']: names[1], [prop + ' 3']: names[2], _variant_ids: ids.join(','), _bundle: '2+1' });

  document.addEventListener('click', async e => {
    const t = e.target;
    if (t.closest('[data-kv-close]')) { e.preventDefault(); closeDrawer(); return; }
    const cartLink = t.closest('a[href$="/cart"], [data-kv-open-cart], #cart-icon-bubble');
    if (cartLink && drawer() && !t.closest('#KlivloCartDrawer')) { e.preventDefault(); openDrawer(); return; }
    const qty = t.closest('[data-kv-qty]');
    if (qty) { e.preventDefault(); await cartRequest('cart/change.js', { id: qty.dataset.key, quantity: +qty.dataset.kvQty }); return; }
    const up = t.closest('[data-kv-upgrade]');
    if (up) { e.preventDefault(); await upgradeToBundle(up); return; }
    const u = t.closest('.kv-useful');
    if (u) { const on = !u.classList.contains('is-on'); u.classList.toggle('is-on', on); u.textContent = on ? u.dataset.on : u.dataset.off; try { localStorage.setItem('kv-useful-' + u.dataset.id, on ? '1' : ''); } catch (_) {} }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  async function upgradeToBundle(btn) {
    const bundleId = +btn.dataset.bundleId, bundleProduct = +btn.dataset.bundleProduct, prop = btn.dataset.prop;
    const cart = await (await fetch(root() + 'cart.js')).json();
    const singles = cart.items.filter(i => i.product_id !== bundleProduct);
    const names = [], ids = [], updates = {}; let left = 3;
    singles.forEach(i => { if (left <= 0) return; const take = Math.min(left, i.quantity); left -= take; for (let k = 0; k < take; k++) { names.push((i.variant_options && i.variant_options[0]) || i.variant_title); ids.push(i.variant_id); } updates[i.key] = i.quantity - take; });
    while (names.length < 3) { names.push(names[0]); ids.push(ids[0]); }
    await fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
    await cartRequest('cart/add.js', { items: [{ id: bundleId, quantity: 1, properties: bundleProps(prop, names, ids) }] });
  }

  function initProduct(sec) {
    if (sec.dataset.kvReady) return; sec.dataset.kvReady = '1';
    const data = JSON.parse($('[data-kv-json]', sec).textContent);
    const mainImg = $('[data-kv-main]', sec), colorLabel = $('[data-kv-color-name]', sec);
    const atc = $$('[data-kv-atc]'), offers = $$('.kv-offer', sec);
    let variantId = data.currentVariant, offer = ($('.kv-offer.is-active input', sec) || {}).value || 'single';
    let priceSingle = data.priceSingle;

    $$('[data-kv-thumb]', sec).forEach(b => b.addEventListener('click', () => { mainImg.src = b.dataset.src; $$('[data-kv-thumb]', sec).forEach(x => x.classList.toggle('is-active', x === b)); }));
    $$('[data-kv-swatch]', sec).forEach(b => b.addEventListener('click', () => {
      variantId = +b.dataset.variant; if (b.dataset.img) mainImg.src = b.dataset.img;
      $$('[data-kv-swatch]', sec).forEach(x => x.classList.toggle('is-active', x === b));
      colorLabel && (colorLabel.textContent = b.dataset.name);
      const u = new URL(location.href); u.searchParams.set('variant', variantId); history.replaceState(null, '', u);
      $$('[data-kv-sticky-img]').forEach(i => b.dataset.img && (i.src = b.dataset.img));
    }));
    offers.forEach(o => $('input', o).addEventListener('change', () => { offer = $('input', o).value; offers.forEach(x => x.classList.toggle('is-active', x === o)); updateLabels(); }));
    function updateLabels() {
      atc.forEach(b => { if (b.disabled && !b.dataset.busy) return; b.textContent = b.dataset.short ? data.addLabel : data.addLabel + ' — ' + (offer === 'bundle' ? data.priceBundle : priceSingle); });
      $$('[data-kv-sticky-price]').forEach(s => s.textContent = offer === 'bundle' ? data.labels.stickyBundle : data.labels.stickySingle);
    }
    updateLabels();
    atc.forEach(b => b.addEventListener('click', async () => {
      atc.forEach(x => { x.disabled = true; x.dataset.busy = '1'; });
      try {
        let items;
        if (offer === 'bundle') {
          const sels = $$('[data-kv-bundle-color]', sec);
          const names = sels.map(s => s.value), ids = sels.map(s => s.selectedOptions[0].dataset.variant);
          items = [{ id: data.bundleVariant, quantity: 1, properties: bundleProps(data.prop, names, ids) }];
        } else items = [{ id: variantId, quantity: 1 }];
        await cartRequest('cart/add.js', { items });
        atc.forEach(x => { if (!x.dataset.short) x.textContent = data.labels.added; });
        setTimeout(updateLabels, 1800);
        openDrawer();
      } catch (err) { alert(err.message); }
      finally { atc.forEach(x => { x.disabled = false; delete x.dataset.busy; }); }
    }));
    const quotes = $$('.kv-quote', sec), dots = $$('.kv-dots button', sec);
    dots.forEach((d, i) => d.addEventListener('click', () => { quotes.forEach((q, k) => q.classList.toggle('is-active', k === i)); dots.forEach((x, k) => x.classList.toggle('is-active', k === i)); }));
    const sticky = $('.kv-sticky'), mainAtc = $('[data-kv-atc]:not([data-short])', sec);
    if (sticky && mainAtc && 'IntersectionObserver' in window) new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainAtc);
  }
  const boot = () => {
    $$('[data-kv-product]').forEach(initProduct);
    $$('.kv-useful').forEach(b => { try { if (localStorage.getItem('kv-useful-' + b.dataset.id)) { b.classList.add('is-on'); b.textContent = b.dataset.on; } } catch (_) {} });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
